<div>
  <mat-tab-group
    class="energy-dashboard-tab"
    dynamicHeight
    [(selectedIndex)]="activeTabIndex"
    (selectedTabChange)="navigate($event)"
  >
    <mat-tab *ngFor="let tab of subTabs" [disabled]="tab.disable">
      <ng-template mat-tab-label
        >{{ tab.label }}
        <div [id]="tab.id"></div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
